import { Reducer } from 'redux';
import { INITIAL_RETURN_ORDER_TRACKING_STATE } from '../../constants';
import {
    RETURN_ORDER_TRACKING_GET,
    RETURN_ORDER_TRACKING_LOADED,
    RETURN_ORDER_TRACKING_CLEAR,
    ReturnOrderTrackingActions,
} from '../actions/returnOrderTrackingActions';
import { ReturnOrderTrackingState } from '../types';

export const returnOrderTrackingReducer: Reducer<ReturnOrderTrackingState, ReturnOrderTrackingActions> = (
    state = INITIAL_RETURN_ORDER_TRACKING_STATE,
    action
): ReturnOrderTrackingState => {
    switch (action.type) {
        case RETURN_ORDER_TRACKING_GET:
            return {
                ...state,
                returnOrderTracking: {
                    value: action.payload.value,
                    error: action.payload.error,
                    status: action.payload.status,
                },
            };
        case RETURN_ORDER_TRACKING_LOADED:
            return {
                ...state,
                returnOrderTracking: {
                    value: action.payload.value,
                    error: action.payload.error,
                    status: action.payload.status,
                },
            };
        case RETURN_ORDER_TRACKING_CLEAR:
            return {
                ...state,
                ...INITIAL_RETURN_ORDER_TRACKING_STATE,
            };
        default:
            return state;
    }
};
